<template>
  <div>
    <slot name="customButton" v-if="customButton"></slot>
    <button
      v-else
      class="btn border btn-block dropdown-toggle d-flex justify-content-between align-items-center"
      :id="`submenu-${id}`"
      data-toggle="dropdown"
      @click="$emit('click')"
    >
      <div>
        <span>{{ label }}</span>
      </div>
      <i class="far fa-times fa-1x" @click="$emit('remove')"></i>
    </button>
    <slot name="menu"></slot>
  </div>
</template>

<script>
export default {
  props: {
    id: String | Number,
    label: String | Number,
    customButton: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.dropdown-toggle::after {
  display: none;
}
</style>
